import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, makeStyles, Typography } from '@popmenu/common-ui';

const useStyles = makeStyles(theme => ({
  button: {
    alignSelf: 'flex-start',
    borderRadius: 24,
    fontWeight: 600,
    minHeight: 48,
    textTransform: 'none',
  },
  container: {
    // The design system's pm-cream, which the theme doesn't have yet
    backgroundColor: '#F4E9E1',
    borderRadius: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.75),
    maxWidth: 560,
    padding: theme.spacing(3),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
}));

type ForYouPromptProps = {
  body: React.ReactNode
  buttonText: React.ReactNode
  title: React.ReactNode
  to: string
}

// What the diner needs to do before For You can rank dishes for them
export const ForYouPrompt = ({ body, buttonText, title, to }: ForYouPromptProps) => {
  const classes = useStyles();

  return (
    <Box aria-labelledby="for-you-prompt-title" className={classes.container} component="section">
      <Typography className={classes.title} component="h2" id="for-you-prompt-title">{title}</Typography>
      <Typography>{body}</Typography>
      <Button className={classes.button} color="primary" component={Link} role="link" to={to} variant="contained">
        {buttonText}
      </Button>
    </Box>
  );
};
